const PLAN_ENABLED = "c-tariffs-section-plan_enabled";

let planes = document.getElementsByClassName("c-tariffs-section-plan");
let currentPlaneIndex = 1;

planes[currentPlaneIndex].className += ` ${PLAN_ENABLED}`;

for (let i = 0; i < planes.length; i++) {
  planes[i].addEventListener('mouseover', function () {
    changeClasses(i);
  });
}

function changeClasses(planeIndex) {
  if (currentPlaneIndex !== planeIndex) {
    planes[currentPlaneIndex].classList.remove(PLAN_ENABLED);
    planes[planeIndex].className += ` ${PLAN_ENABLED}`;
    currentPlaneIndex = planeIndex;
  }
};